import { CategoryQuestions } from '../types';

export const newsMeditationQuestions: CategoryQuestions = {
  title: 'News Meditation - Process Current Events',
  questions: {
    currentNews: {
      label: 'What news is affecting you today? (Paste current headlines, articles, or describe what you heard)',
      type: 'textarea',
      placeholder: 'Paste the news article, headline, or describe what you heard that\'s stressing you out today. Be specific about what\'s bothering you. (Up to 2000 characters)'
    },
    preferredStyle: {
      label: 'How do you want to process this news?',
      type: 'radio',
      options: ['Help me release this stress', 'I need perspective on this', 'I want to stay informed but calm', 'Help me detox from news overwhelm']
    },
    primaryGoal: {
      label: 'What do you want to feel after this session?',
      type: 'radio',
      options: ['Less overwhelmed by current events', 'More grounded in reality', 'Empowered despite the chaos', 'Mentally detoxed from news stress']
    },
    newsConsumption: {
      label: 'How often do you check the news?',
      type: 'select',
      options: ['Constantly throughout the day', 'Several times a day', 'Once or twice daily', 'Weekly or less']
    },
    specificFocus: {
      label: 'What specific aspect of this news is bothering you most?',
      type: 'textarea',
      placeholder: 'Optional - What exactly about this news is getting to you? Fear, anger, helplessness, etc.',
      maxLength: 2000
    },
    explicitLanguageLevel: {
      label: 'Explicit Language Level (1-10)',
      type: 'slider',
      min: 1,
      max: 10,
      defaultValue: 5
    },
    humorLevel: {
      label: 'Humor & Comedy Level',
      type: 'radio',
      options: ['Conservative', 'Moderate', 'Maximum Comedy']
    },
    additionalNotes: {
      label: 'Is there anything else the AI should know to create the perfect session for you?',
      type: 'textarea',
      placeholder: 'Any additional context, special requests, or details that would make this session more meaningful...'
    }
  },
  groupTitle: 'Group News Meditation - Process Current Events Together',
  groupQuestions: {
    groupNewsImpact: {
      label: 'What news is affecting your group today?',
      type: 'textarea',
      placeholder: 'Describe the current events, headlines, or news stories that are stressing out your group...'
    },
    groupNewsContext: {
      label: 'What type of group news processing do you need?',
      type: 'radio',
      options: ['Family dealing with upsetting news', 'Team/workplace discussing current events', 'Friends overwhelmed by news cycle', 'Support group processing collective anxiety', 'Community affected by local news']
    },
    collectiveResponse: {
      label: 'How is your group responding to this news?',
      type: 'radio',
      options: ['Everyone equally stressed/overwhelmed', 'Mixed reactions - some more affected', 'Arguments/disagreements about the news', 'Shared concern and worry', 'Feeling helpless together']
    },
    groupProcessingStyle: {
      label: 'How does your group want to process current events together?',
      type: 'radio',
      options: ['Find shared perspective and grounding', 'Release collective stress and anxiety', 'Discuss rationally while staying calm', 'Support each other through news overwhelm']
    },
    newsConsumption: {
      label: 'How often does your group check/discuss news?',
      type: 'select',
      options: ['Constantly throughout the day', 'Several times a day', 'Once or twice daily', 'Weekly or less', 'Varies widely in the group']
    },
    collectiveGoal: {
      label: 'What does your group want to feel after this session?',
      type: 'radio',
      options: ['Less collectively overwhelmed', 'More grounded in shared reality', 'Empowered to take group action', 'Mentally detoxed from news stress together']
    },
    explicitLanguageLevel: {
      label: 'Explicit Language Level for Group (1-10)',
      type: 'slider',
      min: 1,
      max: 10,
      defaultValue: 5
    },
    humorLevel: {
      label: 'Humor & Comedy Level for Group',
      type: 'radio',
      options: ['Conservative', 'Moderate', 'Maximum Comedy']
    },
    additionalNotes: {
      label: 'Is there anything else the AI should know to create the perfect session for your group?',
      type: 'textarea',
      placeholder: 'Any additional context, special requests, or details that would make this session more meaningful...'
    }
  },
  practitionerGroupTitle: 'Personalize Your Clients\' Group News Meditation - Process Current Events Together',
  practitionerGroupQuestions: {
    groupNewsImpact: {
      label: 'What news is affecting your clients today?',
      type: 'textarea',
      placeholder: 'Describe the current events, headlines, or news stories that are stressing out your clients...'
    },
    groupNewsContext: {
      label: 'What type of group news processing do your clients need?',
      type: 'radio',
      options: ['Family dealing with upsetting news', 'Team/workplace discussing current events', 'Friends overwhelmed by news cycle', 'Support group processing collective anxiety', 'Community affected by local news']
    },
    collectiveResponse: {
      label: 'How are your clients responding to this news?',
      type: 'radio',
      options: ['Everyone equally stressed/overwhelmed', 'Mixed reactions - some more affected', 'Arguments/disagreements about the news', 'Shared concern and worry', 'Feeling helpless together']
    },
    groupProcessingStyle: {
      label: 'How do your clients want to process current events together?',
      type: 'radio',
      options: ['Find shared perspective and grounding', 'Release collective stress and anxiety', 'Discuss rationally while staying calm', 'Support each other through news overwhelm']
    },
    newsConsumption: {
      label: 'How often do your clients check/discuss news?',
      type: 'select',
      options: ['Constantly throughout the day', 'Several times a day', 'Once or twice daily', 'Weekly or less', 'Varies widely in the group']
    },
    collectiveGoal: {
      label: 'What do your clients want to feel after this session?',
      type: 'radio',
      options: ['Less collectively overwhelmed', 'More grounded in shared reality', 'Empowered to take group action', 'Mentally detoxed from news stress together']
    },
    explicitLanguageLevel: {
      label: 'Explicit Language Level for Clients (1-10)',
      type: 'slider',
      min: 1,
      max: 10,
      defaultValue: 5
    },
    humorLevel: {
      label: 'Humor & Comedy Level for Clients',
      type: 'radio',
      options: ['Conservative', 'Moderate', 'Maximum Comedy']
    },
    additionalNotes: {
      label: 'Is there anything else the AI should know to create the perfect session for your clients?',
      type: 'textarea',
      placeholder: 'Any additional context, special requests, or details that would make this session more meaningful...'
    }
  },
  practitionerTitle: 'Personalize Your Client\'s News Meditation - Process Current Events',
  practitionerQuestions: {
    currentNews: {
      label: 'What news is affecting your client today? (Paste current headlines, articles, or describe what they heard)',
      type: 'textarea',
      placeholder: 'Paste the news article, headline, or describe what your client heard that\'s stressing them out today. Be specific about what\'s bothering them. (Up to 2000 characters)'
    },
    preferredStyle: {
      label: 'How does your client want to process this news?',
      type: 'radio',
      options: ['Help them release this stress', 'They need perspective on this', 'They want to stay informed but calm', 'Help them detox from news overwhelm']
    },
    primaryGoal: {
      label: 'What should your client feel after this session?',
      type: 'radio',
      options: ['Less overwhelmed by current events', 'More grounded in reality', 'Empowered despite the chaos', 'Mentally detoxed from news stress']
    },
    newsConsumption: {
      label: 'How often does your client check the news?',
      type: 'select',
      options: ['Constantly throughout the day', 'Several times a day', 'Once or twice daily', 'Weekly or less']
    },
    specificFocus: {
      label: 'What specific aspect of this news is bothering your client most?',
      type: 'textarea',
      placeholder: 'Optional - What exactly about this news is getting to your client? Fear, anger, helplessness, etc.'
    },
    explicitLanguageLevel: {
      label: 'Explicit Language Level for Client (1-10)',
      type: 'slider',
      min: 1,
      max: 10,
      defaultValue: 5
    },
    humorLevel: {
      label: 'Humor & Comedy Level for Client',
      type: 'radio',
      options: ['Conservative', 'Moderate', 'Maximum Comedy']
    },
    additionalNotes: {
      label: 'Is there anything else the AI should know to create the perfect session for your client?',
      type: 'textarea',
      placeholder: 'Any additional context, special requests, or details that would make this session more meaningful...'
    }
  },
  giftTitle: 'Personalize News Meditation for Your Loved One',
  giftQuestions: {
    currentNews: {
      label: 'What news is affecting them? (Describe what they heard that\'s stressing them)',
      type: 'textarea',
      placeholder: 'Describe the news, headlines, or current events that are stressing them out...'
    },
    preferredStyle: {
      label: 'How do they want to process this news?',
      type: 'radio',
      options: ['Help them release this stress', 'They need perspective on this', 'They want to stay informed but calm', 'Help them detox from news overwhelm']
    },
    primaryGoal: {
      label: 'What should they feel after this session?',
      type: 'radio',
      options: ['Less overwhelmed by current events', 'More grounded in reality', 'Empowered despite the chaos', 'Mentally detoxed from news stress']
    },
    additionalNotes: {
      label: 'Anything else the AI should know to create a perfect session for them?',
      type: 'textarea',
      placeholder: 'Any additional context, special requests, or details that would make this session more meaningful...'
    },
    explicitLanguageLevel: {
      label: 'Explicit Language Level (1-10)',
      type: 'slider',
      min: 1,
      max: 10,
      defaultValue: 5
    },
  }
};